function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "wpf:future",
  clipPath: "url(#clip0_3008_43917)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12 0.5V2.34615C6.42004 2.34615 1.84619 6.92 1.84619 12.5C1.84619 18.08 6.42004 22.6538 12 22.6538C17.58 22.6538 22.1539 18.08 22.1539 12.5C22.1539 9.77969 21.1293 7.32154 19.2979 5.49015L18 6.78892C19.4927 8.27969 20.3077 10.2348 20.3077 12.5C20.3077 17.0738 16.5739 20.8077 12 20.8077C7.42619 20.8077 3.69235 17.0738 3.69235 12.5C3.69235 7.92615 7.42619 4.19231 12 4.19231V6.03846L16.6154 3.26923L12 0.5ZM13.933 6.55815L11.6253 11.1735C11.3344 11.2526 11.0777 11.4255 10.8951 11.6653C10.7125 11.9052 10.6142 12.1986 10.6154 12.5C10.6154 12.8672 10.7613 13.2194 11.021 13.4791C11.2806 13.7387 11.6328 13.8846 12 13.8846H12.0582L15.0287 16.856L16.356 15.5286L13.3847 12.5582V12.5C13.3847 12.3182 13.333 12.14 13.2693 11.9803L15.6056 7.36492L13.933 6.55723V6.55815Z",
  fill: "#1E2022"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3008_43917"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgWpfFuture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpfFuture);
export default __webpack_public_path__ + "static/media/wpf_future.5680f01b963c469d25bdab5a91375031.svg";
export { ForwardRef as ReactComponent };